export function getCategories(item) {
  let categories = "";

  item.categories.forEach((category) => {
    categories = `, ${category.title}`;
  });

  return categories;
}
